module.exports = __webpack_public_path__ + "static/images/cross.b8d79e67f87d8b1ba57d7ff36f8852fd.svg";